import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SubscriptionService } from '@core/subscription/subscription.service';
import { AppStoreQuery } from '@core/state/app-state.query';
import { User } from '@core/models/user.model';
import { SnackBarService } from '@feature/snack-bar/snack-bar.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'wai-update-payment-method-dialog',
  templateUrl: './update-payment-method-dialog.component.html',
  styleUrls: ['./update-payment-method-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UpdatePaymentMethodDialogComponent {
  public isSaving = false;
  public billingContactName = '';
  public billingContactEmail = '';

  constructor(
    private dialogRef: MatDialogRef<UpdatePaymentMethodDialogComponent>,
    private subscriptionService: SubscriptionService,
    private appStoreQuery: AppStoreQuery,
    private snackBarService: SnackBarService,
  ) {
    const currentUser = this.appStoreQuery.getValue()?.user as User | undefined;
    if (currentUser) {
      this.billingContactName = currentUser.getFullName() || '';
      this.billingContactEmail = currentUser.email || '';
    }
  }

  public onPaymentMethodCompleted(_paymentMethodId: string): void {
    this.isSaving = true;
    this.subscriptionService
      .getCurrentSubscription(true)
      .pipe(finalize(() => (this.isSaving = false)))
      .subscribe({
        next: () => {
          this.snackBarService.success('INTL_PAYMENT_METHOD_UPDATED');
          this.dialogRef.close(true);
        },
        error: () => {
          this.snackBarService.error('INTL_PAYMENT_METHOD_SAVED_REFRESH_FAILED');
          this.dialogRef.close(true);
        },
      });
  }

  public onCancel(): void {
    this.dialogRef.close(false);
  }
}
